import { createFileRoute } from "@tanstack/react-router";
import MultibookingDetail from "../components/MultibookingDetail";
import AuthGuard from "../components/AuthGuard";

export const Route = createFileRoute("/multibookings/$multibookingGuid/")({
  component: () => (
    <AuthGuard>
      <MultibookingDetail />
    </AuthGuard>
  ),
});
